/**
 * Pon en `false` cuando la integración Canva Connect (backend + API) esté lista.
 * Mientras sea `true`, la UI muestra "Próximamente" y no abre OAuth ni el selector.
 */
export const CANVA_COMING_SOON = false;
